module.exports = __webpack_public_path__ + "static/media/L3.e6f02692.png";